import {RouteObject} from 'react-router';
import {ROUTES} from '../routes';
import {PartnerSitesListing} from './partner-sites-listing';
import {PartnerSiteAdd, PartnerSiteEdit} from './partner-site-create-update';
import {ProtectedRoute} from '../auth/require-authorization';

export const PartnerSiteRoutes: RouteObject = {
  path: ROUTES.ADMIN.PARTNER_SITES.path,
  element: <ProtectedRoute role={'Global Admin'} />,
  children: [
    {
      path: ROUTES.ADMIN.PARTNER_SITES.INDEX.path,
      element: <PartnerSitesListing />,
    },
    {
      path: ROUTES.ADMIN.PARTNER_SITES.CREATE.path,
      element: <PartnerSiteAdd />,
    },
    {
      path: ROUTES.ADMIN.PARTNER_SITES.DETAIL.path,
      element: <PartnerSiteEdit />,
    },
  ],
};
